import { Outlet, useLocation } from "react-router-dom";
import PublicNavbar, { type PublicNavbarActivePage } from "./PublicNavbar";
import PublicFooter from "./PublicFooter";

const ROUTE_TO_ACTIVE: Record<string, PublicNavbarActivePage | undefined> = {
  "/": "home",
  "/pricing": "pricing",
  "/resources": "resources",
  "/reviews": "reviews",
  "/support": "support",
};

const PublicLayout = () => {
  const { pathname } = useLocation();
  const activePage = ROUTE_TO_ACTIVE[pathname];
  return (
    <>
      <PublicNavbar activePage={activePage} />
      <div className="tilprep-public-content">
        <Outlet />
      </div>
      <PublicFooter />
    </>
  );
};

export default PublicLayout;